import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { tasks as tasksApi } from 'redux/modules/api'
import { notification, logError } from 'redux/modules/app'
import { ACTIVITY_SECTIONS } from 'constants/enums'
import { combineAnd } from 'utils/apiFilter'

function decorator(config = {}) {
  return ComposedComponent => {
    const enhance = compose(
      connect(
        ({ api, auth }) => ({
          tasksActivityApproval: api.tasks.activityApproval,
          tasksPhysicalActivityApproval: api.tasks.activityApproval.physical,
          tasksSkillsActivityApproval: api.tasks.activityApproval.skills,
          tasksServiceActivityApproval: api.tasks.activityApproval.service,
          notification,
          logError,
          user: auth.user
        }),
        { ...tasksApi.activityApproval }
      )
    )

    class TasksActivityApproval extends Component {
      static propTypes = {
        tasks: PropTypes.object,
        decoFilter: PropTypes.string,
        decoFilterMyOnly: PropTypes.bool,
        tasksActivityApproval: PropTypes.object.isRequired,
        tasksPhysicalActivityApproval: PropTypes.object.isRequired,
        getTasksActivityApproval: PropTypes.func.isRequired,
        getPhysicalActivityApprovalTasks: PropTypes.func.isRequired,
        getSkillsActivityApprovalTasks: PropTypes.func.isRequired,
        getServiceActivityApprovalTasks: PropTypes.func.isRequired,
        onLoad: PropTypes.func,
        notification: PropTypes.func.isRequired,
        logError: PropTypes.func.isRequired,
        tasksSkillsActivityApproval: PropTypes.object.isRequired,
        tasksServiceActivityApproval: PropTypes.object.isRequired,
        user: PropTypes.object
      }

      defaultProps = {
        tasksActivityApproval: {}
      }

      componentDidMount() {
        const { tasksActivityApproval, decoFilter, decoFilterMyOnly } = this.props

        config.list &&
          this.handleGetTasksActivityApproval(
            tasksActivityApproval,
            this.handleGetBaseFilter(decoFilter, decoFilterMyOnly)
          )
        config.lists && this.handleUpdateLists()
        config.physical && this.handleGetPhysicalActivityApprovalTasks(undefined, this.handleGetBaseFilter())
        config.skills && this.handleGetSkillsActivityApprovalTasks(undefined, this.handleGetBaseFilter())
        config.service && this.handleGetServiceActivityApprovalTasks(undefined, this.handleGetBaseFilter())
      }

      componentWillReceiveProps(nextProps) {
        const {
          tasksActivityApproval,
          tasksPhysicalActivityApproval,
          tasksSkillsActivityApproval,
          tasksServiceActivityApproval,
          decoFilter,
          decoFilterMyOnly
        } = this.props
        const { filter, limit, offset, sort, invalidate } = nextProps.tasksActivityApproval
        const sortPhysical = nextProps.tasksPhysicalActivityApproval.sort
        const sortService = nextProps.tasksServiceActivityApproval.sort
        const sortSkills = nextProps.tasksSkillsActivityApproval.sort

        if (
          tasksActivityApproval.filter !== filter ||
          tasksActivityApproval.limit !== limit ||
          tasksActivityApproval.offset !== offset ||
          tasksActivityApproval.sort !== sort ||
          tasksActivityApproval.invalidate !== invalidate ||
          decoFilter !== nextProps.decoFilter ||
          decoFilterMyOnly !== nextProps.decoFilterMyOnly
        ) {
          config.list &&
            this.handleGetTasksActivityApproval(
              nextProps.tasksActivityApproval,
              this.handleGetBaseFilter(nextProps.decoFilter, nextProps.decoFilterMyOnly)
            )
        }

        if (tasksPhysicalActivityApproval.sort !== sortPhysical) {
          return this.handleGetPhysicalActivityApprovalTasks(
            nextProps.tasksPhysicalActivityApproval,
            this.handleGetBaseFilter(nextProps.decoFilter, nextProps.decoFilterMyOnly)
          )
        }

        if (tasksServiceActivityApproval.sort !== sortService) {
          return this.handleGetServiceActivityApprovalTasks(
            nextProps.tasksServiceActivityApproval,
            this.handleGetBaseFilter(nextProps.decoFilter, nextProps.decoFilterMyOnly)
          )
        }

        if (tasksSkillsActivityApproval.sort !== sortSkills) {
          return this.handleGetSkillsActivityApprovalTasks(
            nextProps.tasksSkillsActivityApproval,
            this.handleGetBaseFilter(nextProps.decoFilter, nextProps.decoFilterMyOnly)
          )
        }
      }

      handleGetBaseFilter = (filter, filterMyOnly) => {
        const { decoFilterMyOnly } = this.props
        const personId = this.props.user.personId

        return combineAnd(this.handleGetBaseDecoFilter(filter),
          filterMyOnly || decoFilterMyOnly
            ? `activity.award.awardLeader.person.id=${personId}`
            : '')
      }

      handleGetBaseDecoFilter = filter => {
        switch (filter || config.filter) {
          case 'physical':
            return `activity.activitySection.value=${ACTIVITY_SECTIONS.physical.id}`
          case 'skills':
            return `activity.activitySection.value=${ACTIVITY_SECTIONS.skills.id}`
          case 'service':
            return `activity.activitySection.value=${ACTIVITY_SECTIONS.service.id}`
          default:
            return ''
        }
      }

      handleGetTasksActivityApproval = (tasks, baseFilter, decoFilter) =>
        this.props
          .getTasksActivityApproval(tasks, baseFilter, decoFilter)
          .then(
            ({ body }) =>
              this.props.onLoad && this.props.onLoad(body && body.length)
          )
          .catch(this.handleError)

      handleGetPhysicalActivityApprovalTasks = (tasks, baseFilter) => {
        this.props
          .getPhysicalActivityApprovalTasks(tasks, baseFilter)
          .then(() => {})
          .catch(this.handleError)
      }

      handleGetSkillsActivityApprovalTasks = (tasks, baseFilter) => {
        this.props
          .getSkillsActivityApprovalTasks(tasks, baseFilter)
          .then(() => {})
          .catch(this.handleError)
      }

      handleGetServiceActivityApprovalTasks = (tasks, baseFilter) => {
        this.props
          .getServiceActivityApprovalTasks(tasks, baseFilter)
          .then(() => {})
          .catch(this.handleError)
      }

      handleUpdateLists = () => {
        this.handleGetPhysicalActivityApprovalTasks(undefined, this.handleGetBaseFilter())
        this.handleGetSkillsActivityApprovalTasks(undefined, this.handleGetBaseFilter())
        this.handleGetServiceActivityApprovalTasks(undefined, this.handleGetBaseFilter())
        // this.handleGetTasksActivityApproval(undefined, this.handleGetBaseFilter('physical'), 'physical')
        // this.handleGetTasksActivityApproval(undefined, this.handleGetBaseFilter('skills'), 'skills')
        // this.handleGetTasksActivityApproval(undefined, this.handleGetBaseFilter('service'), 'service')
      }

      handleError = err => {
        console.log('error', err.body && err.body.userMessage)
        this.props.logError(err)
      }

      render() {
        return (
          <ComposedComponent
            {...this.props}
            tasks={{
              ...this.props.tasks,
              activityApproval: this.props.tasksActivityApproval
            }}
            updateLists={this.handleUpdateLists}
          />
        )
      }
    }
    return enhance(TasksActivityApproval)
  }
}

export default decorator
